import React from 'react';

const About = () => {
  return (
    <div
      name='About'
      className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'
    >
      <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
            About
          </p>
        </div>

        <p className='text-xl mt-5'>
          Hi, my name is Oluwaseun Jayeoba and I have over 5 years of experience
          building and designing software. Currently, I work at Payaza, Nigeria
          and I love to work on web application using technologies like React,
          Vue, Nuxt, Tailwind CSS, NextJS, NestJS and GraphQL.
        </p>

        <br />

        <p className='text-xl'>
          I have got experience developing and deploying web applications.
          Skilled in Javascript, its frameworks, as well as database
          technologies. Comfortable working in a fast-paced environment and able
          to adapt to new technologies quickly. A team player who is also able
          to work independently when required
        </p>
      </div>
    </div>
  );
};

export default About;
